import { ColumnDef } from '@tanstack/react-table';
import type { TopAdData } from '../../hooks/use-social-ads-overview-tab';

export const adsTableColumns: ColumnDef<TopAdData>[] = [
  {
    accessorKey: 'by.name',
    header: 'Ad',
    enableSorting: true,
    enableGlobalFilter: true,
    size: 200,
  },
  {
    accessorKey: 'by.id',
    header: 'Top Creators',
    enableSorting: true,
    enableGlobalFilter: true,
    size: 300,
  },
  {
    accessorKey: 'metrics.roas',
    header: 'ROAS',
    enableSorting: true,
    enableGlobalFilter: true,
    size: 100,
  },
  {
    accessorKey: 'metrics.impressions',
    header: 'Impressions',
    enableSorting: true,
    enableGlobalFilter: true,
    size: 130,
  },
  {
    accessorKey: 'metrics.reach',
    header: 'Reach',
    enableSorting: true,
    enableGlobalFilter: true,
    size: 130,
  },
  {
    accessorKey: 'metrics.clicks',
    header: 'Clicks',
    enableSorting: true,
    enableGlobalFilter: true,
    size: 100,
  },
  {
    accessorKey: 'metrics.spend.amount',
    header: 'Spend',
    enableSorting: true,
    enableGlobalFilter: true,
    size: 120,
  },
  {
    accessorKey: 'metrics.purchase.amount',
    header: 'Sales',
    enableSorting: true,
    enableGlobalFilter: true,
    size: 120,
  },
  {
    accessorKey: 'metrics.cpm',
    header: 'CPM',
    enableSorting: true,
    enableGlobalFilter: true,
    size: 100,
  },
  {
    accessorKey: 'metrics.ctr',
    header: 'CTR',
    enableSorting: true,
    enableGlobalFilter: true,
    size: 100,
  },
  {
    accessorKey: 'metrics.cpc',
    header: 'CPC',
    enableSorting: true,
    enableGlobalFilter: true,
    size: 100,
  },
];
